import React, { type PropsWithChildren, type ReactNode } from "react";
import { type RouteComponentProps, withRouter } from "react-router";
import { ErrorPage } from "./ErrorPage";
import AuthContext from "src/contexts/JWTAuthContext";
import { CaptureSentryError } from "./SentryUtils";
type ErrorBoundaryProps = PropsWithChildren<RouteComponentProps<any>>;

interface ErrorBoundaryState {
    hasError: boolean;
}

class InternalErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        CaptureSentryError(error, errorInfo);
    }

    componentDidUpdate(prevProps: Readonly<ErrorBoundaryProps>): void {
        if (prevProps.location !== this.props.location) {
            this.resetError();
        }
    }

    resetError(): void {
        this.setState({ hasError: false });
    }

    render(): ReactNode | ReactNode[] {
        if (this.state.hasError) {
            return <ErrorPage />;
        }

        return this.props.children;
    }
}

InternalErrorBoundary.contextType = AuthContext;
export const ErrorBoundary = withRouter(InternalErrorBoundary);
